import axios from './axios'

export const getContributor = (code) => {
  return axios.get(`/v2/contributor/${code}`).then(({data}) => data)
}

export const updateContributor = async (id, data) => {
  const formData = new FormData();

  Object.keys(data).forEach(key => formData.append(key, data[key] ?? ''));

  if (data.picture) {
    const res = await fetch(data.picture);
    const blob = await res.blob();
    const file = new File([blob], 'profile', {
      type: 'image/png'
    });
    
    formData.set('picture', file)
  }

  return axios.put(`/v2/contributor/${id}`, formData)
}